import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface TipoPeriodo {
  id?: number;
  nombre: string;
  estado?: number;
}

@Injectable({
  providedIn: 'root',
})
export class TipoPeriodoService {
  private apiUrl = `${environment.apiUrl}/api/tipo-periodos`;

  constructor(private http: HttpClient) {}

  private handleError(error: HttpErrorResponse): Observable<never> {
    console.error('❌ Error tipo-periodos:', error);
    return throwError(() => new Error(error.error?.message || 'Ocurrió un error inesperado.'));
  }

  getAllTipoPeriodos(): Observable<TipoPeriodo[]> {
    return this.http.get<TipoPeriodo[]>(this.apiUrl, { withCredentials: true }).pipe(
      catchError((e) => this.handleError(e))
    );
  }

  createTipoPeriodo(data: TipoPeriodo): Observable<TipoPeriodo> {
    return this.http.post<TipoPeriodo>(this.apiUrl, data, { withCredentials: true }).pipe(
      catchError((e) => this.handleError(e))
    );
  }

  updateTipoPeriodo(id: number, data: TipoPeriodo): Observable<TipoPeriodo> {
    return this.http.put<TipoPeriodo>(`${this.apiUrl}/${id}`, data, { withCredentials: true }).pipe(
      catchError((e) => this.handleError(e))
    );
  }

  deleteTipoPeriodo(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      catchError((e) => this.handleError(e))
    );
  }

  createConfigRodamiento(data: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/api/config-rodamiento`, data, { withCredentials: true }).pipe(
      catchError((e) => this.handleError(e))
    );
  }

  getConfigRodamientos(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/api/config-rodamiento`, { withCredentials: true }).pipe(
      catchError((e) => this.handleError(e))
    );
  }

  getConfigByVehicle(placa: string): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/config-rodamiento/vehicle/${placa}`, { withCredentials: true }).pipe(
      catchError((e) => this.handleError(e))
    );
  }

  getPeriodosByVehicle(placa: string): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/api/pagos-rodamiento/periodos/${placa}`, { withCredentials: true }).pipe(
      catchError((e) => this.handleError(e))
    );
  }

  registrarPago(data: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/api/pagos-rodamiento/pago`, data, { withCredentials: true }).pipe(
      catchError((e) => this.handleError(e))
    );
  }

  registrarPagoMasivo(data: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/api/pagos-rodamiento/pagos-masivos`, data, { withCredentials: true }).pipe(
      catchError((e) => this.handleError(e))
    );
  }

  getPagosByPeriodo(idPeriodo: number | string, placa: string): Observable<any> {
    return this.http
      .get<any>(`${environment.apiUrl}/api/pagos-rodamiento/periodo/${idPeriodo}/placa/${placa}/pagos`, { withCredentials: true })
      .pipe(catchError((e) => this.handleError(e)));
  }

  actualizarPago(idPago: number | string, data: any): Observable<any> {
    return this.http
      .put<any>(`${environment.apiUrl}/api/pagos-rodamiento/pago/${idPago}`, data, { withCredentials: true })
      .pipe(catchError((e) => this.handleError(e)));
  }

  getEstadosPago(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/api/estado-pago`, { withCredentials: true }).pipe(
      catchError((e) => this.handleError(e))
    );
  }

  getEstadoPagoById(id: number): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/estado-pago/${id}`, { withCredentials: true }).pipe(
      catchError((e) => this.handleError(e))
    );
  }

  getReportePagosRealizados(filtros: {
    placa?: string;
    fechaDesde?: string;
    fechaHasta?: string;
    estado?: string;
  } = {}): Observable<any[]> {
    let params = new HttpParams();

    if (filtros.placa) {
      params = params.set('placa', filtros.placa);
    }
    if (filtros.fechaDesde) {
      params = params.set('fechaDesde', filtros.fechaDesde);
    }
    if (filtros.fechaHasta) {
      params = params.set('fechaHasta', filtros.fechaHasta);
    }
    if (filtros.estado) {
      params = params.set('estado', filtros.estado);
    }

    return this.http
      .get<any[]>(`${environment.apiUrl}/api/pagos-rodamiento/reporte/pagos-realizados`, {
        withCredentials: true,
        params
      })
      .pipe(catchError((e) => this.handleError(e)));
  }

  getReporteCartera(filtros: {
    placa?: string;
    fechaDesde?: string;
    fechaHasta?: string;
    estado?: string;
  } = {}): Observable<any[]> {
    let params = new HttpParams();

    if (filtros.placa) {
      params = params.set('placa', filtros.placa);
    }
    if (filtros.fechaDesde) {
      params = params.set('fechaDesde', filtros.fechaDesde);
    }
    if (filtros.fechaHasta) {
      params = params.set('fechaHasta', filtros.fechaHasta);
    }
    if (filtros.estado) {
      params = params.set('estado', filtros.estado);
    }

    return this.http
      .get<any[]>(`${environment.apiUrl}/api/pagos-rodamiento/reporte/cartera`, {
        withCredentials: true,
        params
      })
      .pipe(catchError((e) => this.handleError(e)));
  }
}
